// Lazy chunks 404 after a deploy (hashed filenames change) and also fail on a
// plain network blip. Those two cases need different recovery.

export const DIALOG_CHUNK_RETRIES = 2

export const DIALOG_CHUNK_FAILURE_MESSAGE =
  "Couldn't open that. You're still on this page — try again, or reload if it keeps happening."

export function isChunkLoadError(error) {
  const msg = (error && (error.message || String(error))) || ''
  return (
    /Failed to fetch dynamically imported module/i.test(msg) ||
    /Importing a module script failed/i.test(msg) ||
    /error loading dynamically imported module/i.test(msg) ||
    /'text\/html' is not a valid JavaScript MIME type/i.test(msg) ||
    /Unable to preload CSS/i.test(msg)
  )
}

/**
 * Route navigations have nothing to draw when the view chunk fails, so one
 * reload is the recovery. A dialog opened from a button (Meeting, Edit, …)
 * must stay on the current page — reloading there wipes the list the user
 * is looking at.
 * @param {'navigation' | 'dialog'} source
 * @returns {'reload' | 'stay'}
 */
export function chunkLoadAction(source) {
  return source === 'navigation' ? 'reload' : 'stay'
}

/** @param {number} attempt 1-based tries for this open */
export function dialogChunkAttemptAction(attempt) {
  return attempt <= DIALOG_CHUNK_RETRIES ? 'retry' : 'give-up'
}

export function dialogChunkRetryDelay(attempt) {
  return 400 * attempt
}
